module.exports = __webpack_public_path__ + "images/payrollpanda-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/payrollpanda-logo.png
// module id = 1125
// module chunks = 1